// extracted by mini-css-extract-plugin
module.exports = {"linearGradientSVG":"successGradient_linearGradientSVG__1Mh7x"};